import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Renderer2 } from '@angular/core';
import { LoaderService } from './loader.service';

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent implements OnInit, OnDestroy {
  isLoading$ = this.loaderService.loading$;
  networkText: string = "Checking...";
  networkColor: string = "gray";
  showBars: boolean = true; 

  private unlistenOffline!: () => void;
  private unlistenOnline!: () => void;
  private connection: any;

  constructor(
    private loaderService: LoaderService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.connection =
      (navigator as any).connection ||
      (navigator as any).mozConnection ||
      (navigator as any).webkitConnection;

    if (this.connection) {
      this.updateNetwork(this.connection);
      this.connection.addEventListener("change", () => {
        this.updateNetwork(this.connection);
        this.cdr.detectChanges();
      });
    }

    this.unlistenOffline = this.renderer.listen('window', 'offline', () => {
      this.networkText = "Offline";
      this.networkColor = "#ff1744";
      this.showBars = false;
      this.cdr.detectChanges();
    });

    this.unlistenOnline = this.renderer.listen('window', 'online', () => {
      this.networkText = "Back Online";
      this.networkColor = "#00e676";
      this.showBars = true;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    this.unlistenOffline?.();
    this.unlistenOnline?.();

    if (this.connection) {
      this.connection.removeEventListener("change", () => this.updateNetwork(this.connection));
    }
  }
  updateNetwork(connection: any) {
    const type = connection.effectiveType || "unknown";
    if (type === "4g") {
      this.networkText = "Fast Network...";
      this.networkColor = "#00e676";
      this.showBars = true;
    } else if (type === "3g") {
      this.networkText = "Average Network...";
      this.networkColor = "#ffb300";
      this.showBars = true;
    } else if (type === "2g") {
      this.networkText = "Slow Network...";
      this.networkColor = "#ff1744";
      this.showBars = true;
    } else {
      this.networkText = "Network Unknown...";
      this.networkColor = "#b0bec5";
      this.showBars = true;
    }
  }
}